<template>
  <div id="pack-view">
    <div v-if="!packOk">
      <p class="not-available-message">
        Sorry, this product is not currently available for customers in
        <var>{{ countryName }}</var>.
      </p>
    </div>
    <div v-else-if="packOk">
      <center class="packSelectedQuantity" style="display:none">
        This pack includes both customizable and standardized products.
        <br />You have chosen <var>{{ totalSelected }}</var> out of
        <var>{{ quantity }}</var> {{ productType }} products.
      </center>
      <br  style="display:none"/>
      <div class="row optionSec">
        <div
          class="col-12"
          v-for="(product, i) in productOptionsArray"
        >
          <div v-if="product == 'multivitamin'" class="flex-pack-item-spacing">
            <select
              v-model="pack[productSelectionArray[i]]"
              @change="selectionMade(productSelectionArray[i])"
              class="form-control"
            >
              <option value="undefined" disabled>Select Multi-Vitamin</option>
              <option
                v-for="product in multivitamins"
                :value="product"
                :key="product"
                :disabled="customizableOptions[product]['productSoldOut'] == 1"
                notranslate
              >
                {{ customizableOptions[product]["name"] }}
                <span v-if="customizableOptions[product]['productSoldOut']">
                  - Sold Out</span
                >
              </option>
            </select>
          </div>
          <div v-else-if="product == 'amino'" class="flex-pack-item-spacing">
            <select
              v-model="pack[productSelectionArray[i]]"
              @change="selectionMade(productSelectionArray[i])"
              class="form-control"
            >
              <option value="undefined" disabled>Select Amino</option>
              <option
                v-for="product in aminos"
                :value="product"
                :key="product"
                :disabled="customizableOptions[product]['productSoldOut'] == 1"
                notranslate
              >
                {{ customizableOptions[product]["name"] }}
                <span v-if="customizableOptions[product]['productSoldOut']">
                  - Sold Out</span>
              </option>
            </select>
          </div>
          <div v-else-if="product == 'protein'" class="flex-pack-item-spacing">
            <select
              v-model="pack[productSelectionArray[i]]"
              @change="selectionMade(productSelectionArray[i])"
              class="form-control"
            >
              <option value="undefined" disabled>Select Protein</option>
              <option
                v-for="product in proteins"
                :value="product"
                :key="product"
                :disabled="customizableOptions[product]['productSoldOut'] == 1"
                notranslate
              >
                {{ customizableOptions[product]["name"] }}
                <span v-if="customizableOptions[product]['productSoldOut']">
                  - Sold Out</span>
              </option>
            </select>
          </div>
          <div v-else-if="product == 'hormone'" class="flex-pack-item-spacing">
            <select
              v-model="pack[productSelectionArray[i]]"
              @change="selectionMade(productSelectionArray[i])"
              class="form-control"
            >
              <option value="undefined" disabled>Select Hormone Support</option>
              <option
                v-for="product in hormones"
                :value="product"
                :key="product"
                :disabled="customizableOptions[product]['productSoldOut'] == 1"
                notranslate
              >
                {{ customizableOptions[product]["name"] }}
                <span v-if="customizableOptions[product]['productSoldOut']">
                  - Sold Out</span>
              </option>
            </select>
          </div>
          <div v-else-if="product == 'aminoPlaceholder'" notranslate class="flex-pack-item-spacing">
            {{ productOptions[product]["count"] }} Essential Aminos
          </div>
          <div v-else-if="product == 'multivitaminPlaceholder'" notranslate class="flex-pack-item-spacing">
            {{ productOptions[product]["count"] }} Bio-Active Complete Multi-Vitamin
          </div>
          <div v-else-if="product == 'proteinPlaceholder'" notranslate class="flex-pack-item-spacing">
            {{ productOptions[product]["count"] }} Protein
          </div>
          <div v-else-if="product == 'hormonePlaceholder'" notranslate class="flex-pack-item-spacing">
            {{ productOptions[product]["count"] }} Hormone Support
          </div>
          <div v-else notranslate class="flex-pack-item-spacing">
            {{ productOptions[product]["count"] }} {{ productOptions[product]["name"] }}
          </div>
        </div>
      </div>
      <div v-if="packAlt['ALT_PRODUCT_ID']>0" class="">
       <input type="checkbox" id="packAlt" @click="updatePackId">
       <label for="checkboxAlt"> {{packAlt['ALT_DESCRIPTION'] }} for <strong :data-currency-symbol-left="currencySymbolLeft" :data-currency-symbol-right="currencySymbolRight" notranslate style="color:red">{{ packAlt['PRICE_DIFF'] }}</strong></label>
      </div>
      <div class="product-add-to-cart__price-container">
        <h3 class="product-add-to-cart__price" v-if="retailOnly !=1">
            <span>Member Price: </span>
            <span class="text--orange" :data-currency-symbol-left="currencySymbolLeft" :data-currency-symbol-right="currencySymbolRight" notranslate>{{ totalPrice }}</span>
        </h3>
        <h3 class="product-add-to-cart__price" v-if="this.packRetailPrice > 0">
            <span v-if="retailOnly !=1">Retail Price: </span>
            <span v-else>Price: </span>
            <span class="text--orange" :data-currency-symbol-left="currencySymbolLeft" :data-currency-symbol-right="currencySymbolRight" notranslate>{{ totalPriceRetail }}</span>
        </h3>
      </div>
      <div class="buttonSec" id="productQuantity" v-if="this.packOk && !this.packSoldOut">
        <div v-if="maxQuantity >1" style="padding-left:15px">
           <h4 style="display:inline-block">Quantity: </h4>
           <select v-model="packQuantity">
              <option v-for="(n) in maxQuantity" :value="n" :key="n" notranslate>{{n}}</option>
           </select>
        </div>
        <div class="product-add-to-cart__btn-container">
            <button class="btn btn-success add-to-cart-btn" @click="addtoCart"><i class="fas fa-shopping-cart"></i> Add To Cart</button>
        </div>
        <div
          v-if="errorCount > 1"
          class="selectionMissing selectionHeader bottomError"
        >
          Some product selections are missing
        </div>
        <div
          v-if="errorCount == 1"
          class="selectionMissing selectionHeader bottomError"
        >
          A product selection is missing
        </div>
      </div>
      <div v-else-if="this.packSoldOut">
         <p class="not-available-message">Due to high product demand, this product is temporarily sold out.</p>
      </div>
      <div v-else-if="!this.packOk">
         <p class="not-available-message">Sorry, this product is not currently available for customers in {{ countryName }}.</p>
      </div>
    </div>
  </div>
</template>
<style>
.formControlNonInput {
  border: none;
  box-shadow: none;
  -webkit-box-shadow: none;
}
.flex-pack-item-spacing {
  padding: 0.375rem 0px;
} 
</style>
<script>
import { currencySymbols, euHempCountries } from "./currencySymbols.pl";
import { exchangeRates } from './exchangeRates.pl'
export default {
  props: {
    packId: Number,
    packPrice: Number,
    packRetailPrice: Number,
    altPackId: Number,
    altPackPrice: Number,
    altPackRetailPrice: Number,
    bv: Number,
    quantity: Number,
    countryCode: String,
    countryName: String,
    shippingSuspended: Boolean,
    productOptionsJson: String,
    productOptionsArrayString: String,
    customizableOptionsJson: String,
    customizableOptionsArrayString: String,
    productType: String,
    packAltJson: String,
    retailOnly: Number,
    packOk: Boolean,
    userType: String,
    maxQuantity: Number,
    packSoldOut: Boolean
    //            hasErrorJsonString: String
  },
  data: function () {
    return {
      productOptions: JSON.parse(this.productOptionsJson),
      productOptionsArray: this.productOptionsArrayString.split(","),
      customizableOptions: JSON.parse(this.customizableOptionsJson),
      customizableOptionsArray: this.customizableOptionsArrayString.split(","),
      packAlt: JSON.parse(this.packAltJson),
      placeHolder: "Select Product",
      pack: {},
      //hasError: JSON.parse(this.hasErrorJsonString),
      hasError: {},
      multivitamins: [],
      aminos: [],
      proteins: [],
      hormones: [],
      productSelectionArray: [],
      currentPackId: this.packId,
      packQuantity: '1',
    };
  },
  methods: {
    assembleProducts() {
      var selectionNumber = 0;
      this.productOptionsArray.forEach((value) => {
        if (value == "multivitamin" || value == "amino" || value == "protein" || value == "hormone") {
          selectionNumber++;
          console.log(value, selectionNumber);
          this.productSelectionArray.push(selectionNumber);
        } else {
          this.productSelectionArray.push(0);
        }
      });
      this.customizableOptionsArray.forEach((value) => {
        if (this.customizableOptions[value].type == "multivitamin") {
          this.multivitamins.push(value);
        } else if (this.customizableOptions[value].type == "amino") {
          this.aminos.push(value);
        } else if (this.customizableOptions[value].type == "protein") {
          this.proteins.push(value);
        } else if (this.customizableOptions[value].type == "hormone") {
          this.hormones.push(value);
        }
      });
    },
    selectionMade(x) {
      this.hasError[x] = false;
    },
    updatePackId() {
       if (this.currentPackId == this.packId) {
          this.currentPackId = this.packAlt['ALT_PRODUCT_ID']
       } else {
          this.currentPackId = this.packId
       }
    },
    addtoCart() {
      //console.log(x,this.productOptions[x]['selected'])
      if (this.totalSelected == this.quantity && this.packQuantity != 'QTY' && this.packQuantity!=0) {
        var productsToAdd = {};
        for (var selection in this.pack) {
          var productName = this.currentPackId + "_" + this.pack[selection];
          console.log(productName);
          if (productsToAdd[productName]) {
            productsToAdd[productName] = productsToAdd[productName] + 1;
          } else {
            productsToAdd[productName] = 1;
          }
        }
        productsToAdd[this.currentPackId] = this.packQuantity;
        this.resetPack();
        shoppingCart.addMany(productsToAdd).then((x) => {
        document.getElementById("openCart").click();
//            window.location.href = '/cart'
        });
      } else {
        var tempError = {};
        for (var i = 1; i <= this.quantity; i++) {
          if (this.pack[i] === undefined) {
            console.log(i, "is not selected");
            tempError[i] = true;
          }
        }
        this.hasError = tempError;
      }
    },
    ordinal_suffix_of(i) {
      var j = i % 10,
        k = i % 100;
      if (j == 1 && k != 11) {
        return i + "st";
      }
      if (j == 2 && k != 12) {
        return i + "nd";
      }
      if (j == 3 && k != 13) {
        return i + "rd";
      }
      return i + "th";
    },
    resetPack() {
      for (var i = 1; i <= this.quantity; i++) {
        this.pack[i] = this.placeHolder;
      }
    },
    resetHasError() {
      for (var i = 1; i <= this.quantity; i++) {
        this.hasError[i] = false;
      }
    },
  },
  created: function () {
    this.assembleProducts();
  },
  computed: {
     totalPrice: function () {
         var price = this.packPrice
         if (this.packId != this.currentPackId) {
            price = price + this.packAlt['PRICE_DIFF']
         }
         if (exchangeRates[this.countryCode]) {
            price = price * exchangeRates[this.countryCode]
         }
         var calcQuantity = this.packQuantity
         console.log(this.productId,this.quantity,this.productQuantityDesc)
         if (calcQuantity == '0' || calcQuantity == 'QTY') {
                 calcQuantity = 1
         }
         var tempTotal = price * calcQuantity
         return Number(tempTotal).toFixed(2)
      },
      totalPriceRetail: function () {
         var price = this.packRetailPrice
         if (this.packId != this.currentPackId) {
            price = price + this.packAlt['PRICE_DIFF']
         }
         if (exchangeRates[this.countryCode]) {
            price = price * exchangeRates[this.countryCode]
         }
         var calcQuantity = this.packQuantity
         console.log(this.productId,this.quantity,this.productQuantityDesc)
         if (calcQuantity == '0' || calcQuantity == 'QTY') {
                 calcQuantity = 1
         }
         var tempTotal = price * calcQuantity
         return Number(tempTotal).toFixed(2)
      },
    errorCount: function () {
      console.log("error count");
      var tempCount = 0;
      for (var error in this.hasError) {
        if (this.hasError[error]) {
          tempCount = tempCount + 1;
        }
      }
      console.log("error count", tempCount);
      return tempCount;
    },
    totalSelected: function () {
      var selected = 0;
      for (var i = 1; i <= this.quantity; i++) {
        if (this.pack[i] != this.placeHolder && this.pack[i] !== undefined) {
          console.log(i, this.pack[i]);
          selected = selected + 1;
        }
      }
      return selected;
    },
    remainingQuantity: function () {
      var tempRemaining = this.quantity;
      return 1;
    },
    currencySymbolLeft: function () {
      if (
        !euHempCountries[this.countryCode] &&
        !currencySymbols.left[this.countryCode] &&
        !currencySymbols.right[this.countryCode]
      ) {
        return currencySymbols.left.US;
      } else {
        return currencySymbols.left[this.countryCode];
      }
    },
    currencySymbolRight: function () {
      if (euHempCountries[this.countryCode] && this.countryCode != "GB") {
        return currencySymbols.right.EU;
      } else {
        return currencySymbols.right[this.countryCode];
      }
    },
  },
};
</script>
<style scoped>
.selectionMissing {
  color: red;
}
.bottomError {
  margin: 15px;
}
</style>
